module.exports = __webpack_public_path__ + "img/gemnote_logo_and_text.b8941e01.svg";